const AppLanguage = {
    English: 'en',
    Francais: 'fr',
}

export default AppLanguage
